import { AbstractSearchCore, IFacet, IMultipleResults, ISearchConfig } from '.'

export abstract class AbstractSubscriber {
  groupId: string = ''
  constructor(groupId: string) {
    this.groupId = groupId
  }
  getGroupId(): string {
    return this.groupId
  }
  public setGroupId(groupId: string): void {
    this.groupId = groupId
  }
  abstract attached(searchCore: AbstractSearchCore): Promise<void>
  abstract detaching(): void

  abstract onSearchConfigUpdate(searchConfig: ISearchConfig): Promise<void>
  abstract onSearchTextUpdate(text: string): Promise<void>
  abstract onFacetUpdate(facets: IFacet[]): Promise<void>
  abstract onResultUpdate(result: IMultipleResults): Promise<void>
}
